import { resolveUserRouteReadPermission } from '@glyphic/user-api-types'
import type { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'

import { useUserAuthorization } from '../context/UserAuthorizationContext'
import { useTheme } from '../theme/ThemeContext'
import { ThemedPermissionLoadingState } from './theme/ThemedAccessDeniedState'

type Props = {
  children: ReactNode
}

/** 按 USER_ROUTE_READ_PERMISSION 拦截无 read 权限的路由 */
export function RequireRoutePermission({ children }: Props) {
  const { theme } = useTheme()
  const location = useLocation()
  const { loaded, hasPerm } = useUserAuthorization()
  const required = resolveUserRouteReadPermission(location.pathname)

  if (!loaded) {
    return <ThemedPermissionLoadingState theme={theme} className="flex-1" />
  }

  if (!hasPerm(required)) {
    return <Navigate to="/forbidden" replace state={{ from: location.pathname }} />
  }

  return children
}
